'use client';

import { Star } from 'lucide-react';
import { useTranslations } from 'next-intl';

import { cn } from '@/lib/utils';

interface MealRatingSubmittedProps {
  rating: number;
}

const STAR_VALUES = [1, 2, 3, 4, 5] as const;

export function MealRatingSubmitted({ rating }: MealRatingSubmittedProps) {
  const t = useTranslations('mealRating');

  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <span>{t('yourRating')}</span>
      <span
        className="flex items-center gap-0.5"
        aria-label={t(`starLabels.${rating as 1 | 2 | 3 | 4 | 5}`)}
      >
        {STAR_VALUES.map((star) => (
          <Star
            key={star}
            className={cn(
              'h-4 w-4',
              star <= rating
                ? 'fill-yellow-400 text-yellow-400'
                : 'fill-transparent text-muted-foreground/40',
            )}
          />
        ))}
      </span>
    </div>
  );
}
